/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CEventLinkFlag {
    YOUTUBE = 'YOUTUBE',
    INSTAGRAM = 'INSTAGRAM',
    FACEBOOK = 'FACEBOOK',
}
